// Single source of truth for categories across the app
export const CATEGORIES = [
  "Meals & entertainment",
  "Travel",
  "Office supplies",
  "Vehicle expenses",
  "Fuel",
  "Tools",
  "Home office",
  "Phone/Internet",
  "Repairs",
  "Inventory",
  "Software",
  "Non-Deductible",
  "Other"
] as const;

export type Category = typeof CATEGORIES[number];
